import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'order-confirmation-modal',
    templateUrl: './order-confirmation.modal.html',
    styleUrls: ['./order-confirmation.modal.scss'],
})
export class OrderConfirmationModal {
    @Input() message: string;
    @Input() header: string;

    constructor(public activeModal: NgbActiveModal) {
    }

    
}